import i18n from '@/lang/i18n'

export default function(onSampleNumberClicked) {
    return [
        { type: 'customCheckbox' },
        {
            type: 'text',
            headerName: i18n.tc('registry.requestGrid.subGrid.sampleNumber'),
            field: 'label',
            minWidth: 100,
            flex: 1
        },
        {
            type: 'text',
            headerName: i18n.tc('registry.requestGrid.subGrid.location'),
            field: 'topographicCode.description',
            minWidth: 100,
            flex: 1,
            onCellDoubleClicked: onSampleNumberClicked
        },
        {
            type: 'text',
            headerName: i18n.tc('registry.requestGrid.subGrid.sampleType'),
            field: 'sampleType.description',
            minWidth: 100,
            flex: 1
        },
        {
            type: 'text',
            headerName: i18n.tc('registry.requestGrid.subGrid.procedure'),
            field: 'procedure.description',
            minWidth: 100,
            flex: 1
        },
        {
            type: 'text',
            headerName: i18n.tc('registry.requestGrid.subGrid.mostLikelyDiagnosis'),
            field: 'mostLikelyMorphologicCode.description',
            minWidth: 100,
            flex: 1
        },
        {
            type: 'date',
            headerName: i18n.tc('registry.requestGrid.subGrid.samplingDate'),
            field: 'surSamplingDate',
            minWidth: 100,
            flex: 1
        }
    ]
}
